import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { accountReactivated, accountReactivationFailed, reactivateAccount } from '@/store/actions/authentication/reactivateAccount';

import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* reactivateAccountSaga() {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updatePlaceUserDeletionRequestedAt, token, {
    deletionRequestedAt: null,
  });

  if (!response.error) {
    const responseAction = accountReactivated({ timestamp });
    yield put(responseAction);
  } else {
    const responseAction = accountReactivationFailed({ timestamp });
    yield put(responseAction);
  }
}

export default function* watchReactivateAccountSaga() {
  yield takeEvery(reactivateAccount, reactivateAccountSaga);
}
